import { roles } from 'common/constants';
import _ from 'lodash';

export default function isSeller(rootStore) {
	return (
		_.findIndex(
			rootStore.app.baasic.userHandler.user.user.roles,
			role => role === roles.administrator || role === roles.sellerAccountOwner
		) != -1
	);
}
